import devicesTotalWidgetTemplate from './devicesTotalWidget.html';
import './devicesTotalWidget.scss';

export default angular
  .module('main.dashboardPanel.devicesTotalWidget', [])

  .directive('devicesTotalWidget', () => {
    return {
      restrict: 'E',
      template: devicesTotalWidgetTemplate,
      scope: {},
      controller: ($scope,
                   utils,
                   DashboardDataProvider) => {
        $scope.noData = false;
        init();

        function init() {
          $scope.loading = true;

          DashboardDataProvider.getTotalDevicesLastWeek()
            .then((reportInfo) => {
              $scope.loading = false;
              if (!reportInfo || !reportInfo.dictionary || reportInfo.dictionary.length <= 0 || !reportInfo.executions || reportInfo.executions.length <= 0) {
                $scope.noData = true;
                return;
              }

              let executions = reportInfo.executions
                .slice()
                .sort((a, b) => a.executionDateMs - b.executionDateMs) // latest last
                .map(execution => ({
                  ...execution,
                  total: execution.data?.find((d) => d.id === 1)?.value
                }));

              let lastExecution = executions[executions.length - 1];
              if (!lastExecution.data) {
                $scope.noData = true;
                return;
              }

              $scope.trend = DashboardDataProvider.calculateTrend(executions, 'total');
              $scope.trendDate = new Date(executions[0].executionDateMs);
              $scope.devicesTotal = lastExecution.total;
            }, (err) => {
              utils.handleApiError(err);
              $scope.noData = true;
              $scope.loading = false;
            });
        }
      }
    };
  })
  .name;
